import React from "react";
import Input from "../Forms/Input";
import Button from "../Forms/Button";
import useForm from "../../Custom Hooks/useForm";
import { USER_POST } from "../../api";
import { UserContext } from "../../UserContext";
import useFetch from "../../Custom Hooks/useFetch";
import Error from "../Helper/Error";
import Head from "../Helper/Head";

const LoginCreate = () => {
  const username = useForm();
  const email = useForm("email");
  const password = useForm();

  const { userLogin } = React.useContext(UserContext);

  const { loading, error, request } = useFetch();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { url, options } = USER_POST({
      username: username.value,
      email: email.value,
      password: password.value,
    });

    const fieldsAreValid =
      username.validade() && email.validade() && password.validade();

    if (fieldsAreValid) {
      const { response } = await request(url, options);
      if (response.ok) userLogin(username.value, password.value);
    }
  };

  const buttonStateLoading = <Button disabled>Cadastrando...</Button>;
  const buttonStateNormal = <Button>Cadastrar</Button>;

  return (
    <section className="animeLeft">
      <Head title="Crie sua conta" />
      <h1 className="title">Cadastre-se</h1>
      <form onSubmit={handleSubmit}>
        <Input label="Usuário" type="text" name="username" {...username} />
        <Input label="Email" type="text" name="email" {...email} />
        <Input label="Senha" type="password" name="password" {...password} />
        {loading ? buttonStateLoading : buttonStateNormal}
        <Error error={error} />
      </form>
    </section>
  );
};

export default LoginCreate;
